import { http } from "src/axios";
import type { StoreAccountAssignment } from "./vc-account-assignments-types";

export interface PostVcAccountAssignmentsParams {
  vendorName: string;
  assignments: StoreAccountAssignment[];
  partnerId: string | null;
  notes?: string;
}

export async function postVcAccountAssignments({
  vendorName,
  assignments,
  partnerId,
  notes,
}: PostVcAccountAssignmentsParams) {
  const response = await http.post("/api/v2/vc/accounts/assignments", {
    assignments: assignments.map(({ storeName, accounts }) => ({
      VENDOR_NAME: vendorName,
      STORE_NAME: storeName,
      VC_ACCOUNT_IDS: accounts.map(account => account.avcAccountCredentialsId),
    })),
    partner_id: partnerId || null,
    notes,
  });
  return response.data;
}

export interface DeleteVcAccountAssignmentsParams {
  vcAccountIds: string[];
}

export async function deleteVcAccountAssignment({ vcAccountIds }: DeleteVcAccountAssignmentsParams) {
  const response = await http.delete(`/api/v2/vc/accounts/assignments`, { data: { vc_account_ids: vcAccountIds } });
  return response.data;
}
